import React,{ useState, useEffect } from 'react';
import {AiOutlineUserAdd} from 'react-icons/ai';
import EditIconButton from "../../components/IconButtons/EditIconButton";
import DeleteIconButton from "../../components/IconButtons/DeleteIconButton";
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../../contexts/ContextProvider';
import {useSolicitudesMutations} from '../../hooks';
import {getSolicitudesFiltros} from "../../services/Solicitudes";
import {formatDate} from '../../formatters/date';
import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import DataTable from 'react-data-table-component';
import { NuevaSolicitud, CargarSolicitud } from '../../components';
import {Toaster, toast } from 'react-hot-toast';
import { FolderIcon, UserIcon } from '@heroicons/react/24/solid';

const NavButton = ({ title, customFunc, icon, color, texto }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ backgroundColor: color}}
      className="relative text-xl  text-white rounded-lg p-3 hover:bg-light-gray"
    >
      <div className="flex flex-row justify-between items-center">
        <div>{icon}</div>
        <div><p className="text-xs ">{texto}</p></div>
      </div>
    
    </button>

  </TooltipComponent>
);

const Solicitudes = () => {
  const { currentColor, handleClick, isClicked } = useStateContext();
  const {removeSolicitud} = useSolicitudesMutations();
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('Inicio')); // Fecha inicial
  const [selectedDateEnd, setSelectedDateEnd] = useState(getFirstDayOfMonth('Fin')); // Fecha inicial
  const [estado, setEstado] = useState('ALL');
  const [tipoSolicitud, setTipoSolicitud] = useState('ALL');
  const [archivosData, setArchivosData] = useState([]);
  const [laSucursal, setLaSucursal] = useState("");
  const [numeroSolicitud, setNumeroSolicitud] = useState('');
  const [centroCosto, setCentroCosto] = useState('');

  useEffect(()=>{
    const fetchData = async () => {

      const docuData = await getSolicitudesFiltros(selectedDate.toISOString(),selectedDateEnd.toISOString(),tipoSolicitud,estado , numeroSolicitud, centroCosto);
      setArchivosData(docuData);

    };
    fetchData();
    // rutCliPro,razonSocial
  },[selectedDate,selectedDateEnd,tipoSolicitud,estado, numeroSolicitud, centroCosto]);

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), (today.getMonth()) -3 , 1);
    if(Como === 'Inicio') return firstDay;
    if (Como === 'Fin') {
      // Crea una nueva fecha con la hora 23:59:59
      const endOfDay = new Date(today);
      endOfDay.setHours(23, 59, 59, 999); // 23:59:59.999
      return endOfDay;
    }
    if(Como === 'Nada') return null;
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChangeEnd = (date) => {
    setSelectedDateEnd(date);
  };

  const handleChangeEstado = (e) =>{
    setEstado( e.target.value );
  }

  const handleChangeTipoSolicitud = (e) =>{
    setTipoSolicitud( e.target.value );
  }

  const handleEdit = (sucursalData) => {
    setLaSucursal(sucursalData);
    handleClick('nuevasolicitud');
  };

const handleDescargarExcel = async () => {
  try {
    const url = '/assets/cargasolicitud.xlsm'; // ruta dentro de public/
    const res = await fetch(url);

    if (!res.ok) throw new Error('No se pudo descargar el archivo.');

    const blob = await res.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = 'cargasolicitud.xlsm';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(downloadUrl);
  } catch (err) {
    console.error('Error al descargar Excel:', err);
    // opcional: mostrar notificación al usuario
    alert('Error al descargar el archivo. Intenta nuevamente.');
  }
};

  const handleCargarExcel = () => {
    // console.log('ENTRE');
    handleClick('cargarsolicitud');
    
  };
  
  const handleEliminar = async (row) => {

    if(row.estado ==="Pendiente"){

  toast.custom((t) => (
    <div className="bg-white p-6 rounded-lg shadow-lg w-96 max-w-full">
      <h3 className="text-lg font-semibold">¿Está seguro de Eliminar?</h3>
      <div className="flex justify-end gap-2 mt-4">
        <button
          type="button"
          className="px-4 py-2 bg-gray-400 text-white rounded"
          onClick={() => toast.dismiss(t.id)}
        >
          No
        </button>
        <button
          type="button"
          className="px-4 py-2 bg-red-500 text-white rounded"
          onClick={() => {

            setArchivosData((prevData) => prevData.filter((item) => item._id !== row._id));
            removeSolicitud.mutateAsync(row._id);
            setArchivosData((prevData) =>(prevData));


            toast.dismiss(t.id);
          }}
        >
          Si
        </button>
      </div>
    </div>
  ));


  
    } else {
      toast.error('Solicitud no puede ser eliminada.');
      return;
    }
  };

  const handleRefreshDataTable = (opcion) => {
    // console.log(" OPCION LLEGO -> " + opcion);
    if (opcion==="REFRESH"){
      const fetchData = async () => {
  
        const docuData = await getSolicitudesFiltros(selectedDate.toISOString(),selectedDateEnd.toISOString(),tipoSolicitud,estado , numeroSolicitud, centroCosto);
        setArchivosData(docuData);

      };
      fetchData();
    }
  };

const customStyles = {
  table: {
    style: {
      backgroundColor: 'white',
      borderRadius: '8px',
    },
  },
  head: {
    style: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#2F336A',
      backgroundColor: '#F2F5FE',
      borderBottom: '1px solid #D9E1F2',
    },
  },
  headRow: {
    style: {
      minHeight: '48px',
      borderBottomWidth: '1px',
    },
  },
  headCells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      whiteSpace: 'nowrap',
    },
  },
  rows: {
    style: {
      fontSize: '13px',
      backgroundColor: 'white',
      minHeight: '52px',
      borderBottom: '1px solid #F3F4F6',
      transition: 'background-color 0.2s ease-in-out',
    },
    highlightOnHoverStyle: {
      backgroundColor: '#F9FAFB',
      borderBottomColor: '#E5E7EB',
      outline: 'none',
    },
  },
  cells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
    },
  },
};


  const columns = [
  {
    name: '',
    width: '40px',
    cell: (row) => (
      <EditIconButton onClick={() => handleEdit(row)} />
    )
  },
  {
    name: '',
    width: '40px',
    cell: (row) => (
      <DeleteIconButton onClick={() => handleEliminar(row)} />
    )
  },
  {
    name: 'N°',
    width: '80px',
    selector: row => row.numeroSolicitud,
    sortable: true
  },
  {
    name: 'Fecha',
    width: '120px',
    selector: row => formatDate(row.fechaCreacion),
    sortable: true
  },
  {
    name: 'C.Costo',
    width: '100px',
    selector: row => row.codigoCentro,
    sortable: true
  },
  {
    name: 'Proyecto',
    width: '320px',
    selector: row => row.nombreProyecto,
    sortable: true,
    cell: (row) => (
      <div className="flex items-center gap-2">
        <FolderIcon className="w-4 h-4 text-blue-500" />
        <span>{row.nombreProyecto}</span>
      </div>
    )
  },
  {
    name: 'Estado',
    width: '120px',
    selector: row => row.estado,
    sortable: true,
    cell: (row) => {
      let bgColor = '';
      switch (row.estado) {
        case 'Aprobada':
          bgColor = 'bg-green-100 text-green-700';
          break;
        case 'Pendiente':
          bgColor = 'bg-yellow-100 text-yellow-700';
          break;
        case 'Rechazada':
          bgColor = 'bg-red-100 text-red-700';
          break;
        case 'En Proceso':
          bgColor = 'bg-blue-100 text-blue-700';
          break;
        default:
          bgColor = 'bg-gray-100 text-gray-700';
      }
      return (
        <div className={`text-xs px-2 py-1 rounded-full text-center ${bgColor}`}>
          {row.estado}
        </div>
      );
    }
  },
    {
    name: 'Tipo',
    width: '120px',
    selector: row => row.tipoSolicitud,
    sortable: true
  },
  {
    name: 'Solicitante',
    width: '250px',
    selector: row => row.nombreSolicitante,
    sortable: true,
    cell: (row) => (
      <div className="flex items-center gap-2">
        <UserIcon className="w-4 h-4 text-blue-500" />
        <span>{row.nombreSolicitante}</span>
      </div>
    )
  }
];


  return (

<>
<div className="mx-4 lg:mx-12 mt-4">
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                 Solicitudes
              </p>
            </div>
        </div>

      {isClicked.nuevasolicitud && (<NuevaSolicitud vecinoData={laSucursal} onChangeVecino={handleRefreshDataTable}/>)}
      {isClicked.cargarsolicitud && (<CargarSolicitud onChangeVecino={handleRefreshDataTable}/>)}


      <div className="bg-white p-6 rounded-lg shadow-lg mt-2">
        <div className="flex justify-start items-center p-2 md:ml-6 md:mr-6 relative top-1">
          <div className="grid grid-cols-1 md:grid-cols-9 gap-4 w-full">
            
            {/* Fecha Desde */}
            <div className="col-span-2">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">Desde</label>
              <SeleccionaFecha
                selectedDate={selectedDate}
                handleDateChange={handleDateChange}
              />
            </div>

            {/* Fecha Hasta */}
            <div className="col-span-2">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">Hasta</label>
              <SeleccionaFecha
                selectedDate={selectedDateEnd}
                handleDateChange={handleDateChangeEnd}
              />
            </div>

            {/* Tipo Solicitud */}
            <div className="col-span-1">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">Tipo Solicitud</label>
              <select
                className="text-xs border border-gray-300 p-2 rounded w-full"
                name="tipoSolicitud"
                value={tipoSolicitud}
                onChange={handleChangeTipoSolicitud}
              >
                <option value="ALL">Todos</option>
                <option value="Entrada">Entrada</option>
                <option value="Salida">Salida</option>
                <option value="Adicional">Adicional</option>
                <option value="Reemplazo">Reemplazo</option>
                <option value="Traspaso">Traspaso</option>
              </select>
            </div>

            {/* Estado */}
            <div className="col-span-1">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">Estado</label>
              <select
                className="text-xs border border-gray-300 p-2 rounded w-full"
                name="estado"
                value={estado}
                onChange={handleChangeEstado}
              >
                <option value="ALL">Todos</option>
                <option value="Pendiente">Pendiente</option>
                <option value="En Proceso">En Proceso</option>
                <option value="Aprobada">Aprobada</option>
                <option value="Rechazada">Rechazada</option>
              </select>
            </div>

            {/* N° Solicitud */}
            <div className="col-span-1">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">N° Solicitud</label>
              <input
                type="text"
                className="text-xs border border-gray-300 p-2 rounded w-full"
                placeholder="Ej: 10234"
                value={numeroSolicitud}
                onChange={(e) => setNumeroSolicitud(e.target.value)}
              />
            </div>

            {/* Centro Costo */}
            <div className="col-span-1">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">Centro Costo</label>
              <input
                type="text"
                className="text-xs border border-gray-300 p-2 rounded w-full"
                placeholder="Ej: 0451"
                value={centroCosto}
                onChange={(e) => setCentroCosto(e.target.value)}
              />
            </div>
            {/* Botón agregar */}

            <div className="flex items-end col-span-1">
              <NavButton
                title="Agregar Solicitud"
                customFunc={() => {
                  setLaSucursal('');
                  handleClick('nuevasolicitud');
                }}
                color={currentColor}
                icon={<AiOutlineUserAdd />}
                texto=" Solicitud"
              />
            </div>

          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 gap-4 w-full mt-4">
            <div className="flex items-end col-span-1">
              <button
                type="button"
                onClick={handleDescargarExcel}
                className="underline text-green-800 hover:text-green-900 whitespace-nowrap"
              >
                Descargar formato Carga Solicitud Excel.
              </button>
            </div>
            <div className="flex items-end col-span-1">
              <button
                type="button"
                onClick={handleCargarExcel}
                className="underline text-green-500 hover:text-green-900 whitespace-nowrap"
              >
                Crear Solicitud desde formato Excel.
              </button>
            </div>  
        </div>

      </div>


      <div className="bg-white p-6 rounded-lg shadow-lg items-end mt-4">   
        <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
            <div className="flex flex-col">
              <DataTable
                columns={columns}
                data={archivosData}
                highlightOnHover
                pagination={true}
                striped
                className="border border-gray-300 rounded-lg shadow-sm"
                noHeader={true}
                selectableRowsHighlight
                customStyles={customStyles}
                noDataComponent={'No hay Solicitudes creadas'}
              />
            </div>
        </div>
      </div>
</div>

    <Toaster
      position="top-right"
      toastOptions={{
        style: {
          zIndex: 9999,
        },
      }}
    />  
    </>
  );
};

export default Solicitudes;